import batteryVertical from '../../../assets/svg/battery-utilita-vertical.svg';
import batteryIcon from '../../../assets/svg/batteryUtilita.svg';
import elecIcon from '../../../assets/svg/elecUtilita.svg';
import gridIcon from '../../../assets/svg/gridUtilita.svg';
import helpIcon from '../../../assets/svg/help-utilita.svg';
import exportIcon from '../../../assets/svg/icon/export-utilita.svg';
import importIcon from '../../../assets/svg/icon/import-utilita.svg';
import infoPrimary from '../../../assets/svg/info-primary-utilita.svg';
import inverterIcon from '../../../assets/svg/inverter-utilita.svg';
import solarIcon from '../../../assets/svg/solarUtilita.svg';
import type { SVGIcons } from '../ThemeTypes';

import colors from './colors';

const icons: SVGIcons = {
  solar: solarIcon,
  battery: batteryIcon,
  batteryForEquipmentOnboarding: batteryVertical,
  grid: gridIcon,
  electricity: elecIcon,
  export: exportIcon,
  import: importIcon,
  help: helpIcon,
  inverter: inverterIcon,
  info: infoPrimary,
  styles: {
    svgIcon: {
      width: '42px',
      height: '42px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '8px',
      marginRight: 'auto',
      marginLeft: 'auto',
      '${min.sm}': {
        width: '60px',
        height: '60px',
        marginBottom: '0',
        marginRight: '16px',
      },
    },
    gridIcon: {
      border: `2px solid ${colors.icons.gridIconBorder}`,
      background: colors.icons.gridIconBackground,
      img: {
        width: '22px',
        '${min.sm}': {
          width: '31px',
        },
      },
    },
    consumptionIcon: {
      background: colors.icons.consumptionIconBackground,
      img: {
        width: '25px',
        '${min.sm}': {
          width: '38px',
        },
      },
    },
    solarIcon: {
      background: colors.icons.solarIconBackground,
      img: {
        width: '28px',
        '${min.sm}': {
          width: '38px',
        },
      },
    },
    batteryIcon: {
      background: colors.icons.batteryIconBackground,
      img: {
        width: '25px',
        '${min.sm}': {
          width: '38px',
        },
      },
    },
  },
};

export default icons;
